<template>
  <v-row class="fill-height" no-gutters>
    <v-col cols="9" class="left-column pa-3">
      <div v-if="cart.items.length <= 0" class="empty-cart">
        <v-icon size="150">mdi-cart-off</v-icon>
        <div>There are no items in the cart...</div>
        <v-btn color="primary" class="ma-3" @click="browseCatalog()">
          <v-icon class="mr-3">mdi-view-grid-outline</v-icon>Browse Catalog
        </v-btn>
      </div>
      <div v-else class="d-flex flex-column justify-start align-center">
        <table class="line-items">
          <thead>
            <tr>
              <th class="quantity-column">QTY</th>
              <th class="picture-column"></th>
              <th class="name-column"></th>
              <th v-for="column in config.cartColumns" :key="column.id">
                {{ column.name }}
              </th>
              <th class="price-column">
                {{
                  dealer.pricelists.length > 0 && dealer.pricelists[0]
                    ? dealer.pricelists[0].name
                    : "Price"
                }}
              </th>
              <th class="action-column"></th>
              <th class="action-column"></th>
              <th class="action-column"></th>
            </tr>
          </thead>
          <cart-item-row
            v-for="item in cart.items"
            :key="item.id"
            :item="item"
          ></cart-item-row>

          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align: right">
                <b>{{ config.cartColumns.length <= 0 ? "Total:" : "" }}</b>
              </td>
              <td
                v-for="(column, index) in config.cartColumns"
                :key="column.id"
                style="text-align: right"
              >
                {{ index == config.cartColumns.length ? "Total:" : "" }}
              </td>
              <td>
                <v-progress-circular
                  v-if="allPeople.length"
                  indeterminate
                ></v-progress-circular>
                <b v-else>{{ cart.price }}</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <v-btn
          color="error"
          @click="clearCart()"
          :loading="clearing"
          :disabled="clearing"
          >Clear Cart</v-btn
        >
      </div>
    </v-col>
    <v-col cols="3" class="right-column pa-3">
      <v-card>
        <v-card-title>
          Total:
          <v-progress-circular
            v-if="allPeople.length"
            indeterminate
            size="30"
            class="ml-3"
          ></v-progress-circular>
          <span v-else>{{ cart.price }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-dialog v-model="dialog" width="500" :persistent="placing">
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                v-on="on"
                :disabled="allPeople.length > 0 || cart.items.length == 0"
                >Checkout</v-btn
              >
            </template>

            <v-card :loading="placing">
              <v-card-title>Checkout</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form class="mt-3">
                  <v-text-field
                    label="First Name"
                    v-model="retailQuote.Rtl_Qt_FirstName"
                  ></v-text-field>
                  <v-text-field
                    label="Last Name"
                    v-model="retailQuote.Rtl_Qt_LastName"
                  ></v-text-field>
                  <v-text-field
                    label="Email Address"
                    v-model="retailQuote.Rtl_Qt_EmailAddress"
                  ></v-text-field>
                  <v-text-field
                    label="Phone Number"
                    v-model="retailQuote.Rtl_Qt_PhoneNumber"
                  ></v-text-field>
                  <v-select
                    label="Preferred Contact Method"
                    :items="contactMethods"
                    v-model="retailQuote.Rtl_Qt_PreferredContactMethod"
                  ></v-select>
                  <v-text-field
                    label="Zip Code"
                    v-model="retailQuote.Rtl_Qt_ZipCode"
                  ></v-text-field>
                  <v-text-field
                    v-if="config.showCheckoutMemo"
                    label="Memo"
                    v-model="retailQuote.Rtl_Qt_Memo"
                  ></v-text-field>
                  <v-checkbox
                    label="I would like to receive exclusive emails and offers"
                    v-model="retailQuote.Rtl_Qt_Promotions"
                  ></v-checkbox>
                </v-form>
                <v-alert
                  v-for="warning in cart.warnings"
                  :key="warning"
                  dense
                  type="warning"
                  >{{ warning }}</v-alert
                >
                <v-alert
                  v-for="error in cart.errors"
                  :key="error"
                  dense
                  type="error"
                  >{{ error }}</v-alert
                >
                <v-alert v-if="checkoutError" dense type="error">{{
                  checkoutError
                }}</v-alert>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary" @click="placeOrder(true)">Quote</v-btn>
                <v-btn
                  v-if="config.checkoutMethod.CheckoutMethodId != 'acm1.none'"
                  color="primary"
                  @click="placeOrder(false)"
                  :disabled="cart.errors.length > 0"
                  >Order</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="error" @click="clickClose()">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CartItemRow from "../components/CartItemRow";

export default {
  components: {
    CartItemRow,
  },
  data: function () {
    var dev = false;

    return {
      checkoutError: "",
      contactMethods: ["Email", "Phone"],
      dialog: false,
      placing: false,
      clearing: false,
      retailQuote: {
        Rtl_Qt_FirstName: dev ? "Michael" : "",
        Rtl_Qt_LastName: dev ? "Bilsborough" : "",
        Rtl_Qt_EmailAddress: dev ? "mike@amptab.com" : "",
        Rtl_Qt_PhoneNumber: dev ? "425-123-1234" : "",
        Rtl_Qt_PreferredContactMethod: dev ? "Email" : "",
        Rtl_Qt_ZipCode: dev ? "12345" : "",
        Rtl_Qt_Memo: dev ? "Hello Mike!" : "",
        Rtl_Qt_Promotions: false,
      },
    };
  },
  computed: {
    allPeople: function () {
      return this.$store.getters.allPeople;
    },
    slideshow: function () {
      return this.$store.state.slideshow;
    },
    dealer: function () {
      return this.$store.state.dealer;
    },
    config: function () {
      return this.$store.state.config;
    },
    cart: function () {
      return this.$store.getters.clientCart;
    },
  },
  methods: {
    clearCart: async function () {
      try {
        this.clearing = true;
        await this.$store.dispatch("clearCart2");
      } catch (error) {
        alert(error);
      } finally {
        this.clearing = false;
      }
    },
    placeOrder: async function (quoteOnly) {
      try {
        this.checkoutError = "";
        this.placing = true;
        var orderId = await this.$store.dispatch("placeOrder", {
          commitmentOnly: quoteOnly,
          retailQuote: this.retailQuote,
        });
        this.dialog = false;
        var url = `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/DisplayOrder/${orderId}`;
        this.$router.push(url);
      } catch (error) {
        this.checkoutError = `Something went wrong. Maybe invalid email`;
      } finally {
        this.placing = false;
      }
    },
    clickClose: function () {
      this.dialog = false;
    },
    browseCatalog: function () {
      this.$store.commit("clearPath");
      this.$router.push(
        `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Path`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-cart {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
  font-size: 24px;
}

.summary-table {
  width: 100%;
  th {
    text-align: left;
  }
  td {
    text-align: left;
  }
}

.left-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.75);
}

.right-column {
  background-color: white;
}

.cart-items {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  .cart-item {
    margin: 10px;
  }
}
</style>

<style lang="scss">
//Shop3/Cart.scss
$amp-dark: rgb(120, 120, 120);

#cart {
  margin-top: 20px;
}

#items-column {
  box-shadow: inset -20px 0px 20px -20px rgba($amp-dark, 0.5);
}

#actions-column {
  border-left: 1px solid $amp-dark;
}

.line-items {
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      border-bottom: 1px solid black;
    }
  }

  td,
  th {
    padding: 10px;
    vertical-align: top;
    font-size: 12px;
    color: gray;
    text-align: left;
    //border: 1px solid black;
  }

  thead {
    .quantity-column {
      width: 75px;
    }
    .picture-column {
      width: 150px;
    }
    .name-column {
    }
    .price-column {
      width: 100px;
    }
    .action-column {
      width: 75px;
    }
  }
}

.line-item {
  border-bottom: 2px solid black;

  tr.line-item-details {
    .line-item-image {
      max-width: 125px;
      max-height: 125px;
      width: auto;
      height: auto;
    }

    .name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 3px;
    }

    .sku {
      font-size: 14px;
      font-style: italic;
      margin-bottom: 3px;
    }

    .description {
      font-size: 10px;
      margin-bottom: 0px;
    }

    .action-button {
      background-color: white;
      border: none;
      cursor: pointer;
      transition: transform 0.1s ease-in-out;
      color: black;
      height: 100%;
      display: inline-block;
      padding: 0px;

      &:hover {
        transform: scale(1.1);
      }
      i {
      }
      p {
        margin: 0px;
        font-size: 10px;
      }
    }
  }

  tr.line-item-notes {
    .filled {
      background-color: lightgoldenrodyellow;
    }

    input {
      border: none;
    }

    td {
      padding-top: 0px;
      padding-bottom: 20px;
    }
  }
}
</style>